import { GoInfo } from 'react-icons/go';
import { usePrevalenceBreakdownStore } from '@/store/prevalenceBreakdownStore';
import { getPrevalenceSummary, parsePrevalenceData } from '@/utils/prevalence';

type PrevalenceCellProps = {
  data: any;
};

export function PrevalenceCell({ data }: PrevalenceCellProps) {
  const setPrevalenceBreakdownRow = usePrevalenceBreakdownStore(s => s.setPrevalenceBreakdownRow);
  const entries = parsePrevalenceData({
    disease_prevalence_class: data?.disease_prevalence_class,
    disease_prevalence_geo_area: data?.disease_prevalence_geo_area,
    disease_prevalence_type: data?.disease_prevalence_type,
  });

  if (entries.length === 0) return <span>-</span>;

  return (
    <div className="flex items-center gap-1">
      <span>{getPrevalenceSummary(entries)}</span>
      <button
        type="button"
        aria-label="View prevalence breakdown"
        onClick={event => {
          event.stopPropagation();
          setPrevalenceBreakdownRow(data);
        }}
      >
        <GoInfo className="w-5 h-4 stroke-1 text-blue m-1" />
      </button>
    </div>
  );
}
